import Const from 'constants';
import {StackItem} from 'components/organisms/player-combination-stacking/stack-item';
import {generateSignature} from 'helpers/hash';

const defaultStateData = {
    stackItems: {},
};

const defaultState = {
    data: cp(defaultStateData),
    enabled: true,
    signature: null,
    all() {
        return {...this.data};
    },
    isEnabled() {
        return Boolean(this.enabled);
    },
    getItems() {
        return this.data.stackItems;
    },
    hasItems() {
        return !isEmpty(this.data.stackItems);
    },
    getItem(itemId) {
        return this.data.stackItems[itemId];
    },
    getSignature() {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.PLAYER_COMBINATION_STACKING_SET_IS_USED) {
        state.enabled = Boolean(action.use);
    } else if (action.type === Const.PLAYER_COMBINATION_STACKING_ADD_ITEM) {
        const {stackItem} = action;
        state.data.stackItems[stackItem.getId()] = stackItem;
    } else if (action.type === Const.PLAYER_COMBINATION_STACKING_REMOVE_ITEM) {
        delete state.data.stackItems[action.itemId];
    } else if (action.type === Const.PLAYER_COMBINATION_STACKING_SET_DATA_FROM_STORAGE) {
        const {stackItems} = action.data;

        Object.values(stackItems).map((stackItemDataStruct) => {
            const stackItem = new StackItem(cp(stackItemDataStruct.data));

            state.data.stackItems[stackItem.getId()] = stackItem;
        });
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
            enabled: true,
            signature: generateSignature(),
        };
    }

    return state;
}
